import { ThemeColor, ThemeTonalRange } from '@philips-emr/tws-constants';
import { ConfigurationService, HistoryService, HttpService, LanguageService, LocaleService, MessageService, ThemeService, ToastService } from '@philips-emr/tws-core/lib/services';
import { HttpMethod } from '@philips-emr/tws-core/lib/services/http-service';
import { applicationContext, foundationContext, Information } from '@philips-emr/tws-foundation';

import { RootRoutes } from '../codegen';
import { Endpoints } from '../definitions/endpoints';
import { Configuration, Wsuite } from '../services/configuration';

import { setupDinamico } from './module-registry/dinamico';
import { setupModules } from './modules';

const COLOR_RANGE_ALIASES: Record<string, ThemeColor> = {
  'dark-green': ThemeColor.UNIMED,
};

function resolveColorRange(dsColorRange?: string): ThemeColor {
  const isValidColorRange = Object.values(ThemeColor).includes(dsColorRange as ThemeColor);
  const themeColor = isValidColorRange ? dsColorRange as ThemeColor : ThemeColor.GREEN;
  return COLOR_RANGE_ALIASES[dsColorRange ?? ''] || themeColor;
}

function bootstrap(): Promise<void> {
  ConfigurationService.setAuthenticationConfiguration({
    clientId: 'beneficiary',
    endpointMappers: {
      // @ts-ignore
      information: (data: object) => data.body as Information,
    },
    endpoints: {
      information: {
        url: Endpoints.GET.INFORMATION,
        method: HttpMethod.GET,
      },
      refresh: {
        url: Endpoints.POST.REFRESH,
        method: HttpMethod.POST,
      },
      revoke: {
        url: Endpoints.POST.REVOKE,
        method: HttpMethod.POST,
      },
    },
    inactivity: {
      time: 15 * 60 * 1000,
    },
    routes: {
      custom: [
        RootRoutes.ROUTE_CONFIRMAR_USUARIO,
        RootRoutes.ROUTE_NOVA_SENHA,
      ],
      forgotPassword: RootRoutes.ROUTE_RECUPERAR_SENHA,
      home: RootRoutes.ROUTE_REDIRECT,
      inactivity: RootRoutes.ROUTE_INACTIVITY,
      login: RootRoutes.ROUTE_LOGIN,
    },
  });

  applicationContext.setTitle(MessageService.translate('beneficiary.application-name'));
  foundationContext.setHideModuleSearch(true);
  foundationContext.setCanEditEstablishment(false);
  foundationContext.setCanEditProfile(false);
  foundationContext.setCanEditSector(false);

  setupDinamico();
  setupModules();

  const wsuite = HttpService.get<Wsuite>(Endpoints.GET.CONFIGURACAO)
    .then(({ body }) => {
      const wsuiteResponse = body || {} as Wsuite;
      let { dsAccentColor, dsNavTonalRange, dsLoginTonalRange } = wsuiteResponse;

      const dsColorRange = resolveColorRange(wsuiteResponse.dsColorRange);
      dsAccentColor = dsAccentColor || ThemeColor.AQUA;
      dsLoginTonalRange = dsLoginTonalRange || ThemeTonalRange.ULTRA_LIGHT;
      dsNavTonalRange = dsNavTonalRange || ThemeTonalRange.BRIGHT;

      ThemeService.setColors(dsColorRange, dsAccentColor as ThemeColor.AQUA);
      ThemeService.setContentTonalRange(dsLoginTonalRange);
      ThemeService.setNavigationTonalRange(dsNavTonalRange);

      return wsuiteResponse;
    });

  LanguageService.setCurrentLanguage('pt-br');
  LocaleService.init({ defaultLocale: 'pt-br', supportedLocales: ['pt-br', 'en-us'] });

  HistoryService.addListener(() => {
    ToastService.closeAll();
    return Promise.resolve();
  });

  Configuration.init(wsuite);
  return Promise.all([wsuite]).then(() => Promise.resolve());
}

export {
  bootstrap,
};
